import { downloadCSV } from "Utils/csv";
import { BaseDataItem, DataKeyConfig } from "./types";
import { DateTime } from "luxon";
import { SET_ADMIN_EXPORT_DATE_STRING } from "Utils/date";

export function barChartToCsv<T extends BaseDataItem>(
  data: T[],
  dataKeys: Partial<Record<keyof T, DataKeyConfig>>,
  chartName: string,
) {
  const dataKeyArray = Object.keys(dataKeys);
  const csvHeaders = dataKeyArray.map(
    (k) => dataKeys[k]?.legendLabel ?? "No Label",
  );
  csvHeaders.unshift("Month");

  const csvRows = data.map((d) => {
    return [d.label, ...dataKeyArray.map((k) => d[k] ?? 0)];
  });

  const now = DateTime.now()
    .setZone("America/Chicago")
    .toFormat(SET_ADMIN_EXPORT_DATE_STRING);

  downloadCSV(
    csvHeaders,
    csvRows,
    `${chartName}_${now}.csv`.replaceAll(" ", "_"),
  );
}
